import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { Agent } from "@/types";

// #245 (Teil B): Connection-Wake opt-in setzen. PATCH /agents/:id/connection-wake
// (Owner/Admin). true = Master weckt den Agent aktiv, sobald eine ausgehende
// Verbindungsanfrage akzeptiert wird. Invalidiert ["resources","agents"].

function useConnectionWakeClient() {
  const { session, logout } = useAuth();
  return () =>
    createApiClient({
      getToken: () => session?.accessToken ?? null,
      onUnauthorized: logout,
    });
}

export function useUpdateConnectionWake(
  agentId: string,
): UseMutationResult<Agent, Error, boolean> {
  const qc = useQueryClient();
  const getClient = useConnectionWakeClient();
  return useMutation({
    mutationFn: (wakeOnAccepted) =>
      getClient().patch<Agent>(`/agents/${agentId}/connection-wake`, { wakeOnAccepted }),
    onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.resource("agents") }),
  });
}
